import React from "react";

function Buttoon({ href, children, className, style, classNameBtn, onClick }) {
  return (
    <div className={`relative ${className} `}>
      <div
        className=" w-full h-full absolute 
       bg-transparent 
       shadow-btn rounded-full"
        style={{ backgroundColor: "#1c1c1c" }}
      ></div>
      <a
        href={href}
        className={`flex transform 
        bg-primary 
        items-center btn-effect
        rounded-full px-10 py-3 
        shadow-md transition-all duration-150 text-white
        cursor-pointer
        text-xl ${classNameBtn}`}
        style={style}
        onClick={onClick}
        // onClick={() => history.push("/template")}
      >
        {children}
      </a>
    </div>
  );
}

export default Buttoon;
